export default __webpack_public_path__ + "static/media/Table.62434f6a.svg";